import { Action } from '../actions';
import { mergeObject } from '../helpers';

export function onlineOfflineReducer(state = {}, action: Action) {
  switch (action.type) {
    case 'WS_MESSAGE':
      if (action.payload.parent_type === 'onlineoffline') {
        const { data } = action.payload;
        return Object.entries(data).reduce(
          (s, [userId, status]) =>
            mergeObject<'onlineOffline'>(
              s,
              { status },
              { path: ['onlineOffline', userId] },
            ),
          state,
        );
      }

      return state;

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// /mnt/jenkins-slave-workspace/workspace/gaf-build-i18n-webapp-compat/LANG/pl/webapp/src/app/@shared/datastore/online-offline/online-offline.reducer.ts